// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.input-display[data-v-00411e40] {\r\n  margin-left: 1rem;\n}\n.input-display label[data-v-00411e40]:first-child {\r\n  margin-bottom: 0;\n}\n.input-display label[data-v-00411e40]:last-child {\r\n  font-weight: normal;\n}\r\n", ""]);
// Exports
module.exports = exports;
